import React, { useState } from 'react'
import { IProps } from './index'
import { Text } from '../../elements/Text'
import { BrandOptions, useBrand } from 'marketing-site/src/library/providers/brandProvider/'
import { CheckBox as CheckBoxDefault } from './component'
import styles from './style.scss'

export const CheckBox = (props: IProps) => {
  const theme = useBrand()
  if (theme === BrandOptions.default) {
    return <CheckBoxDefault {...props} />
  }
  return <CheckBoxLegacy {...props} />
}

const CheckBoxLegacy: React.FC<IProps> = ({ checked, label, onChange }: IProps) => {
  const [isChecked, setIsChecked] = useState<boolean>(checked)
  const toggleChecked = () =>
    setTimeout(() => {
      setIsChecked((checked: boolean) => {
        // Calling this inside `useEffect` could easily introduce infinite loops or stale callbacks.
        if (onChange) onChange(!checked)
        return !checked
      })
    }, 1)

  return (
    // eslint-disable-next-line
    <button
      className="checkbox"
      role="checkbox"
      aria-label={label}
      onClick={toggleChecked}
      data-testid="checkbox"
      aria-checked={isChecked}
    >
      <span className="checkbox__icon-wrap">
        {isChecked ? (
          <svg
            width="14"
            height="14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="checkbox__checked-icon"
          >
            <path
              d="M3.719 12c-.302 0-.503-.1-.704-.4L.101 7.191c-.202-.3-.101-.8.301-1.101.302-.2.804-.1 1.005.3L3.72 9.797l.301-.501s0-.1.1-.1l.503-.601 1.91-2.805.503-.6v-.1L8.04 3.886l.904-1.402s0-.1.1-.1l.503-.601.402-.801c.1 0 .1 0 .1-.1l.604-.601c.301-.3.804-.401 1.105-.1.302.3.302.8.1 1.101l-.502.601-.402.701-.1.1-.503.601-.904 1.403s0 .1-.1.1L8.341 6.09l-.402.6-2.01 2.905s0 .1-.1.1l-.503.601-.905 1.402c-.2.2-.402.301-.703.301z"
              fill="#000"
            />
          </svg>
        ) : (
          <span className="checkbox__unchecked-icon" />
        )}
      </span>
      <Text size="body">{label}</Text>
      <style jsx>{styles}</style>
    </button>
  )
}
